

// Create the translations javascript variable so other functions can be attached
// to it.
let translations = {"g":{"close":"Close","done":"Done","hidden":"Hidden","hide":"Hide","no_results":"No Results","none":"None","unknown_problem":"An unknown problem occurred.","save":"Save","saved":"Saved","something_went_wrong":"Something has gone wrong. Please refresh and try again."},"hot_sheets":{"index":{"error_updating":"Sorry, the Hot Sheet could not be updated."},"filter_modal":{"error_loading":"Sorry, the Hot Sheet filters could not be loaded.","error_saving":"Sorry, the Hot Sheet filters could not be saved."}},"listings":{"actions":{"recommended_successfully":"Listing recommended successfully.","removed_successfully":"Listing removed successfully.","saved_successfully":"Listing saved successfully."},"add_to_collection_modal":{"cart_add_failure":"Listing could not be added to collection","error_creating_collection":"There was an error creating the collection.","listing_added":"The listing has been added to the collection."},"index":{"error_setting_rating":"Sorry, there was an error setting your rating."}},"location":{"placeholder_text":"Enter Location"},"map":{"discard":"Discard","discard_warning_message":"Are you sure you want to delete the selected shape?","error":"There was an error updating the map. Please try again.","invalid_shape":"Invalid Shape","invalid_shape_message":"The shape you drew had invalid boundaries. This sometimes happens unintentionally when trying to close the shape. You can automatically close the shape by double tapping when marking your last point.","legend":"Legend","keep":"Keep","delete_shape":"Delete Shape","yes_im_sure":"Yes, I'm sure","cancel":"Cancel","add_to_filter":"Add to Filter","remove_from_filter":"Remove from Filter"},"maps":{"overlays_legend_popover":{"source":"Source"}},"saved_searches":{"index":{"error_toggling_favorites":"An error occurred. Please try again later."}},"showing_instructions":{"index":{"title":"Showing Info","error":"There was an error loading the showing information for this listing. Please try again later."}},"subscription_toggle":{"error_message":"Sorry, there was an error processing your request."},"collections":{"index":{}},"newsfeed_groups":{"bulk_unsubscribe_modal":{},"index":{}},"open_houses":{"index":{}}};


// Define the count functions. The number has to be replaced with javascript 
// because the erb is only computed once when the js is compiled.

  translations.collections.index.mass_delete_error = function(count) {
    if(count === 1){
      return '1 Listing Collection could not be deleted.';
    } else {
      return '### Listing Collections could not be deleted.'.replace('###', count);
    }        
  };

  translations.newsfeed_groups.bulk_unsubscribe_modal.are_you_sure_agent = function(count) {
    if(count === 1){
      return 'Are you sure you want to remove agent notifications from one subscription?';
    } else {
      return 'Are you sure you want to remove agent notifications from ### subscriptions?'.replace('###', count);
    }        
  };

  translations.newsfeed_groups.bulk_unsubscribe_modal.are_you_sure_contact_click = function(count) {
    if(count === 1){
      return 'Are you sure you want to remove contact click notifications from one subscription?';
    } else {
      return 'Are you sure you want to remove contact click notifications from ### subscriptions?'.replace('###', count);
    }        
  };

  translations.newsfeed_groups.index.error_deleting = function(count) {
    if(count === 1){
      return 'One of the subscriptions could not be deleted.';
    } else {
      return '### subscriptions could not be deleted.'.replace('###', count);
    }        
  };

  translations.open_houses.index.destroy_error = function(count) {
    if(count === 1){
      return 'The open house could not be deleted.';
    } else {
      return '### open houses could not be deleted.'.replace('###', count);
    }        
  };

  translations.open_houses.index.destroy_notice = function(count) {
    if(count === 1){
      return 'The open house was successfully deleted.';
    } else {
      return 'The open houses were successfully deleted.'.replace('###', count);
    }        
  };

  translations.saved_searches.index.error_deleting = function(count) {
    if(count === 1){
      return 'One saved search could not be deleted.';
    } else {
      return '### saved searches could not be deleted.'.replace('###', count);
    }        
  };



// Other custom translations functions can be defined below. Just make sure the
// translations object structure is there before you try to assign a function, 
// and be careful not to override any objects that may have been defined above.

translations.shared ||= {};
translations.shared.bulk_delete_modal ||= {};
translations.shared.bulk_delete_modal.are_you_sure = function(resourceType, count) {
  var message = '';

  if(resourceType === 'collection'){
    message = 'Are you sure you want to delete ### collections?';
  } else if (resourceType === 'newsfeed_group'){
    message = 'Are you sure you want to delete ### subscriptions?';
  }  else if (resourceType === 'open_house'){
    message = 'Are you sure you want to delete ### open houses?';
  } 
  
  return message.replace("###", count);
}

translations.shared ||= {};
translations.shared.delete_modal ||= {};
translations.shared.delete_modal.are_you_sure = function(name) {
  return 'Are you sure you want to delete "this"?'.replace("this", name);
}


export {translations};
